import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input, Message, TextField } from "@zendeskgarden/react-textfields";
import t from "@zendesk/client-i18n-tools";
import validateRuleName from "state/validateRuleName";

import {
  EditIcon,
  ClickToEdit,
  Placeholder,
} from "@zendesk/knowledge-components/lib/ClickToEdit";

import styles from "./styles.css";

export default class RuleNameClickToEdit extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
  };

  render() {
    const { onSubmit, value } = this.props;

    const showValidation = !validateRuleName(value);
    const validation = showValidation ? "error" : "none";

    return (
      <ClickToEdit
        input={getInputProps => (
          <TextField>
            <Input
              {...getInputProps({
                "data-test-id": "rule-name-input",
                placeholder: t("knowledge-verification.ruleNamePlaceholder"),
                validation,
              })}
            />
            <Message
              data-test-id="rule-name-validation"
              validation={validation}
              style={{ display: showValidation ? "inherit" : "none" }}
            >
              {t("knowledge-verification.ruleNameMissing")}
            </Message>
          </TextField>
        )}
        placeholder={getPlaceholderProps => (
          <Placeholder
            {...getPlaceholderProps({
              "data-test-id": "rule-name-input-placeholder",
              className: styles.placeholder,
            })}
          >
            {value}
            <EditIcon size={18} />
          </Placeholder>
        )}
        value={value}
        onSubmit={onSubmit}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RuleNameClickToEdit/index.js